// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__I_zya","addWidgetButton":"Header_addWidgetButton__1zkqT","dashboardTabs":"Header_dashboardTabs__Nan_F","active":"Header_active__17907"};